import styled from 'styled-components';
import { colors } from '../../utils/styles/colors';
import { media } from '../../utils/styles/media';

export const SignUpContainer = styled.div`
    position: fixed;
    top:0;
    left: 0; 
    width: 100vw;
    height: 100vh;
    background-color: ${colors.modalBackground};
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
    form{
        width: 700px;
        background-color: white;
        border-radius: 20px;
        padding: 20px;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        //justify-content: space-between;
         //min-height: 950px;
        max-height: 95%;
        ::-webkit-scrollbar-thumb{
            background-color: transparent;
            //border:  #BCBCBC 10px solid;
            //border-top: 25px solid transparent;
            //border-bottom: 25px solid transparent; 
        }
        .header{
            display: flex;
            justify-content: space-between;
            .title{
                font-family: 'Open Sans',  sans-serif;
                font-weight: bold;
                font-size: 2.1rem;
                color: ${colors.darkGrey};
            }
            .close{
                width: 25px;
            }
        }
        .message{
            margin-bottom: 10px;
            color: ${colors.darkGrey};
        }
        .buttons{
            display: flex;
            justify-content: space-between;
            margin: 5px 0;  
        }
        .registerButton{
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            margin-top: 15px;
            .error{
                font-size: 0.7rem;
                color: red;
                padding-bottom: 10px;
            }
        }
        .generalButton{
                padding: 10px 20px;
                background-color:  ${colors.grey};
                color: #ffffff;
                border-radius: 10px;
                border: none;
                width: 49%;
                font-size: 1rem;
                font-weight: 600;
                cursor: pointer;
            }
        .active{
                background-color: ${colors.hightlight};
            }
        .name{
            display: flex;
            justify-content: space-between;
            margin-top: 10px;
            .inputContainer{
                width: 49%;
                display: flex;
                border:1px solid ${colors.grey};
                border-radius: 10px;
                .influencerName, .influencerLastName{
                    width: 100%;
                    outline: none;
                    border: none;
                    //font-size: 1rem;
                    font-size: 1.1rem;
                    ::placeholder{
                        //font-size: 1rem;
                        font-size: 1.1rem;
                        font-family: 'Open Sans', sans-serif;
                        font-weight: bold;
                        color: rgba(112,112,112,0.51);
                    }
                }
                .check{
                    //padding-right: 10px;
                    height: 19px;
                    width: 19px;  
                }
            }
            
        }
        /* .phone{
            display: flex;
            justify-content: space-between;
            align-items: center;
            .inputContainer{
                width: 82%;
            }
            
        } */
        
        .inputContainer{
            display: flex;
            border:1px solid ${colors.grey};
            border-radius: 10px;
            padding: 10px;
            margin: 5px 0;
            .icon{
                padding-right: 10px;
                width: 35px;
            }
            .check{
                //padding-right: 10px;
                height: 19px;
                width: 19px;
            }
        }
        .companyNameContainer{
            margin-top: 10px;
        }
        .error{
            color: red;
            font-size: 0.7rem;
            padding-bottom: 5px;
        }
        .influencerIdContainer{
            display: flex;
            justify-content: space-between;
            align-items: center;
            #react-select-2-listbox{
                z-index: 150;
            }
            #react-select-3-listbox{
                z-index: 150;
            }
            #react-select-4-listbox{
                z-index: 150;
            }
            .influencerId{
                margin-left: 8px;
            }
        }
        .password, .email, .phone, .companyName{
            width: 100%;
            outline: none;
            border: none;
            //font-size: 1rem;
            font-size: 1.1rem;
            ::placeholder{
                //font-size: 1rem;
                font-size: 1.1rem;
                font-family: 'Open Sans', sans-serif;
                font-weight: bold;
                color: rgba(112,112,112,0.51);
            }
            
        }
        
        .influencerId, .influencerPronoun{
            width: 100%;
            padding: 10px;
            border-radius: 10px;
            outline: none;
            border:1px solid ${colors.grey};
            margin: 5px 0;
            //font-size: 1rem;
            font-size: 1.1rem;
            ::placeholder{
                //font-size: 1rem;
                font-size: 1.1rem;
                font-family: 'Open Sans', sans-serif;
                font-weight: bold;
                color: rgba(112,112,112,0.51);
            }
        }
        .birthdayTitle{
            //padding-top: 5px;
            color: ${colors.darkGrey};
            margin-bottom: 5px;
            font-weight: bold;
            color: rgba(112,112,112,0.51);
            font-size: 1.2rem;
        }
        .date{
            width: 100%;
            .DatePicker{
                width: 100%;
                .inputPicker{
                    font-size: 1.1rem;
                    padding: 10px !important;
                    ::placeholder{
                        font-size: 1.1rem;
                        font-family: 'Open Sans', sans-serif;
                        font-weight: bold;
                        color: rgba(112,112,112,0.51);
                    } 
                }
            } 
            
        }
        .genderTitle, .relationshipTitle{
            padding-top: 4px;
            color: ${colors.darkGrey};
            font-weight: bold;
            color: rgba(112,112,112,0.51);
            font-size: 1.2rem;
        }
        .genders, .relationships{
            display: flex;
            justify-content: space-between;
            color: ${colors.greyLetter};
            //font-size: 1rem;
            font-size: 1.1rem;
            font-family: 'Open Sans', sans-serif;
            font-weight: bold;
            color: rgba(112,112,112,0.51);
            .gender, .relationship{
                padding: 9px 10px;
                border-radius: 10px;
                outline: none;
                border:1px solid ${colors.grey};
                margin: 4px 0;
                width: 32%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                //font-size: 0.8rem;
                input[type="radio"]{
                    accent-color: ${colors.hightlight};
                }
                
            }
        }
        .accept{
            display: flex;
            align-items: flex-start;
            margin-top: 10px;
            /* .inputAccept{
                margin-right: 5px;
                accent-color: ${colors.hightlight};
                margin-top: 2px;
            } */
             /* input[type='checkbox'] {
                -moz-appearance:none;
                -webkit-appearance:none;
                -o-appearance:none;
                outline: none;
                content: none;
                margin: 0;
                padding: 0;	
            } 

            input[type='checkbox']:before {
                font-family: "FontAwesome";
                content: "\f00c";
                font-size: 10px;
                color: transparent !important;
                background: #ffffff;
                display: block;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 10px;
                height: 10px;
                border:0.7px solid ${colors.grey};
                border-radius: 3px;
                margin-right: 3px;
                margin-top: 2px;
            }

            input[type='checkbox']:checked:before {
                color: ${colors.hightlight} !important;
            } */

            input[type='checkbox'] {
            margin-right: 8px;
            margin-left: 4px;
            -ms-transform: scale(1.5); /* IE */
            -moz-transform: scale(1.5); /* FF */
            -webkit-transform: scale(1.5); /* Safari y Chrome */
        }
            input[type='checkbox'] {
            -moz-appearance:none;
            -webkit-appearance:none;
            -o-appearance:none;
            outline: none;
            content: none;	
        }

        input[type='checkbox']:before {
            font-family: "FontAwesome";
            content: "\f00c";
            font-size: 10px;
            color: transparent !important;
            background: #ffffff;
            display: block;
            width: 10px;
            height: 10px;
            border:0.7px solid ${colors.grey};
            border-radius: 2px;
            //margin-right: 4px;
        }

        input[type='checkbox']:checked:before {
            color: ${colors.hightlight} !important;
        }
            
            .acceptText{
                font-size: 0.7rem;
                color: ${colors.grey};
                a{
                    //color: ${colors.darkGrey};
                    color: ${colors.grey};
                    text-decoration: underline;
                }
            }
        }
        
    }

    /**-----------Responsive----------- */
    ${media.largeDesktop}{
        form{
            width: 500px;
            //min-height: 700px;
            .accept{
                /* input[type='checkbox']:before {
                    font-size: 15px;
                    width: 15px;
                    height: 15px;
                } */
            }
        }
    }
    ${media.bigmacdesktop}{
        form{
            .name{
                .inputContainer{
                    .influencerName, .influencerLastName{
                        font-size: 0.9rem;
                        font-size: 1rem;
                        ::placeholder{
                            font-size: 0.9rem;
                            font-size: 1rem;
                        }
                    }
                    
                }
            }
            .password, .email, .phone, .companyName{
                font-size: 0.9rem;
                font-size: 1rem;
                ::placeholder{
                    font-size: 0.9rem;
                    font-size: 1rem;
                }
            }
            .influencerId, .influencerPronoun{
                font-size: 0.9rem;
                font-size: 1rem;
                ::placeholder{
                    font-size: 0.9rem;
                    font-size: 1rem;
                }
            }
            .date{
                .DatePicker{
                    .inputPicker{
                        font-size: 0.9rem;
                        font-size: 1rem;
                        ::placeholder{
                            font-size: 0.9rem;
                            font-size: 1rem;
                        } 
                    }
                }
            }
            .genderTitle, .relationshipTitle, .birthdayTitle{
                font-size: 1.1rem;
            }
            .genders, .relationships{
                font-size: 0.9rem;
                font-size: 1rem;
            }
        }
    }
    ${media.desktop}{
        form{
            width: 450px;
            .name{
                .inputContainer{
                    .influencerName, .influencerLastName{
                        font-size: 0.9rem;
                        ::placeholder{
                            font-size: 0.9rem;
                        }
                    }
                }
            }
            .password, .email, .phone, .companyName{
                font-size: 0.9rem;
                ::placeholder{
                    font-size: 0.9rem;
                }
            }
            .influencerId, .influencerPronoun{
                font-size: 0.9rem;
                ::placeholder{
                    font-size: 0.9rem;
                }
            }
            .date{
                .DatePicker{
                    .inputPicker{
                        font-size: 0.8rem;
                        font-size: 0.9rem;
                        ::placeholder{
                            font-size: 0.8rem;
                            font-size: 0.9rem;
                        } 
                    }
                }
            }
            .genderTitle, .relationshipTitle, .birthdayTitle{
                font-size: 1rem;
            }
            .genders, .relationships{
                //font-size: 0.8rem;
                font-size: 0.9rem;
            }
        }
    }
    ${media.smallDesktop}{
        form{
            width: 430px;
            //min-height: 480px;
        }
    }
    ${media.laptop}{
        form{
            width: 450px;
            //min-height: 650px;
        }
    }

    ${media.largeMobile}{
        background-color: #ffffff;
        position: inherit;
        height: 100%;
        align-items: flex-start;
        form{
            width: 100%;
            height: 100%;
            padding: 30px;
            border-radius: 0;
            .header{
                .close{
                    display: none;
                }
            }
            .buttons{
                flex-direction: column;
            }
            .generalButton{
                width: 100%;
                margin-bottom: 10px;
            }
            .register{
                width: 70%;
                border-radius: 30px;
                margin-top: 20px;
            }
        }
    }

    ${media.smallMobile}{
        form{
            .name{
                .inputContainer{
                    .influencerName, .influencerLastName{
                        font-size: 0.8rem;
                        ::placeholder{
                            font-size: 0.8rem;
                        }
                    }
                }
            }
            .password, .email, .phone, .companyName{
                font-size: 0.8rem;
                ::placeholder{
                    font-size: 0.8rem;
                }
            }
            .influencerId, .influencerPronoun{
                font-size: 0.8rem;
                ::placeholder{
                    font-size: 0.8rem;
                }
            }
            .date{
                .DatePicker{
                    .inputPicker{
                        font-size: 0.8rem;
                        ::placeholder{
                            font-size: 0.8rem;
                        } 
                    }
                }
            }
            .birthdayTitle{
                font-size: 0.9rem;
                padding-top: 0;
            }
            .genderTitle, .relationshipTitle{
            font-size: 0.9rem;
            }
            .genders, .relationships{
                .gender, .relationship{
                    font-size: 0.8rem; 
                }
            }
        }
    }

    ${"@media(max-width: 385px)"}{
        form{
            .genders, .relationships{
                .gender, .relationship{
                    font-size: 0.7rem; 
                }
            }
        }
    }
`